import React from 'react';

/** Plain text stays plain text; HTTPS payment/help links remain usable on mobile. */
export default function CustomerChatText({ text }) {
  return <p className="whitespace-pre-wrap break-words [overflow-wrap:anywhere]">
    {String(text || '').split(/(https:\/\/[^\s<>]+)/g).map((part, index) =>
      /^https:\/\//.test(part)
        ? <a key={index} href={part} target="_blank" rel="noopener noreferrer" className="underline break-all">{part}</a>
        : part)}
  </p>;
}
